import { render, staticRenderFns } from "./other-info.html?vue&type=template&id=36b6e33b&scoped=true&external"
import script from "./other-info.js?vue&type=script&lang=js&external"
export * from "./other-info.js?vue&type=script&lang=js&external"
import style0 from "./other-info.scss?vue&type=style&index=0&id=36b6e33b&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b6e33b",
  null
  
)

export default component.exports